import classnames from 'classnames';
import * as React from 'react';
import {
    Col, Nav, NavItem,
    NavLink, Row, TabContent, TabPane
} from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../hooks';
import { EntityContactRole, EntityUserRole } from '../redux/ContactSlice';
import { getSelectedEntity, selectedEntityAddress } from '../redux/EntitySlice';
import Page from './Page';
import CanShowGivenAuthorizedContactUserRoles from './feature/CanShowGivenAuthorizedContactUserRoles';
import EntityContactsManager from './feature/EntityContactsManager';


const EntityManagement = () => {
    const dispatch = useAppDispatch();
    const entityAddressSelector = useAppSelector(selectedEntityAddress);
    const entitySelector = useAppSelector(getSelectedEntity);

    //fiscal due date hooks
    const [fiscalDay, setFiscalDay] = React.useState<number | null>(null);
    const [fiscalMonth, setFiscalMonth] = React.useState<number | null>(null);

    //entity status hooks
    const [dissolvedDate, setDissolvedDate] = React.useState<string | null>(null);
    const [entityStatus, setEntityStatus] = React.useState<string | null>(null);

    //address hooks
    const [street, setStreet] = React.useState<string | null>(null);
    const [zipCode, setZipCode] = React.useState<string | null>(null);
    const [pobox, setPobox] = React.useState<string | null>(null);
    const [state, setState] = React.useState<string | null>(null);
    const [county, setCounty] = React.useState<string | null>(null);
    const [cityCode, setCityCode] = React.useState<string | null>(null);

    //visual hook
    const [activeTab, setActiveTab] = React.useState('1');

    const toggle = (tab: any) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    React.useEffect(() => {
        if (entityAddressSelector) {
            setStreet(entityAddressSelector.street);
            setZipCode(entityAddressSelector.zip);
            setPobox(entityAddressSelector.pobox);
            setState(null);
            setCounty(null);
            setCityCode(entityAddressSelector.city.code);
        }
        else {
            setStreet(null);
            setZipCode(null);
            setPobox(null);
            setState(null);
            setCounty(null);
            setCityCode(null);
        }
    }, [entityAddressSelector])

    React.useEffect(() => {
        if (entitySelector) {
            setDissolvedDate(entitySelector.dissolvedDate);
            setFiscalMonth(entitySelector.fiscalEndMonth);
            setFiscalDay(entitySelector.fiscalEndDay);
            setEntityStatus(entitySelector.status);
        }
        else {
            setDissolvedDate(null);
            setFiscalMonth(null);
            setFiscalDay(null);
            setEntityStatus(null);
        }
    }, [entitySelector]);

    return (
        <Page>
            <CanShowGivenAuthorizedContactUserRoles
                entityContactRole={EntityContactRole.PRIMARY}
                entityUserRole={EntityUserRole.EDITOR}
                reportAccess={null}
            >
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => { toggle('1'); }}>
                        Edit Users
                    </NavLink>
                </NavItem>           
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Row>
                        <Col sm="12">
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <EntityContactsManager isStaff={false} />
                        </Col>
                    </Row>
                </TabPane>
                </TabContent>
            </CanShowGivenAuthorizedContactUserRoles>
        </Page>
    );
}


export default EntityManagement;